import { render, staticRenderFns } from "./RegistrationSetup.vue?vue&type=template&id=b4260e28&"
import script from "./RegistrationSetup.vue?vue&type=script&lang=js&"
export * from "./RegistrationSetup.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSetup.vue?vue&type=style&index=0&id=b4260e28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports